import styled from 'styled-components/macro'
import { ReactComponent as ArrowLeftIcon } from '../../../assets/arrow_left.svg'

export const PaginationWrap = styled.div`
  text-align: right;
`
export const PaginationContent = styled.div`
  display: flex;
  padding: 0.5rem 0;
  font-size: 0.7rem;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: end;
`

export const PageButton = styled.a<{ pageOn?: boolean; disabled?: boolean }>`
  display: flex;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  &:hover {
    background-color: #d7d7d8;
  }
  color: ${(props) => (props.pageOn ? '#0097FE' : 'inherit')};
`

export const PageButtonWrap = styled.span<{ disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) => (props.disabled ? 'inherit' : '#0097FE')};
  text-decoration: ${(props) => !props.disabled && 'underline'};
  display: flex;
`

export const TotalPageBox = styled.span`
  padding-left: 0.35rem;
`

export const ArrowRightIcon = styled(ArrowLeftIcon)`
  transform: rotate(180deg);
`

export const PageText = styled.div`
  white-space: nowrap;
`
